module.exports = __webpack_public_path__ + "img/arrow-up.6e006ce8.svg";